<script>
  import { updateApp } from '../functions/update-app.js'
  import { RELOAD_HANDLING_TYPES } from '../constants.js'
  import pkg from '../../package.json';

  const version = pkg.version
  const commit = pkg.gitCommitHash
</script>

<p class="text-align-center">
  🎀<br/>
  snepchat version {version} ({commit})<br />

  <button class="-button-link" on:click={() => updateApp(RELOAD_HANDLING_TYPES.ASK)}>
    force app update
  </button>
</p>

<style>
  p,
  button {
    font-size: 0.8rem;
  }
</style>
